<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>绑定计划</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="小计划号:" prop="distributionNo">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.distributionNo"></el-input>
      </el-form-item>
      <el-form-item label="港口:" prop="wharfId">
        <el-select v-model="searchFrom.wharfId" placeholder="请选择" @change="portOptionChange">
          <el-option
            v-for="(item,index) in portOptions"
            :key="index"
            :label="item.showName"
            :value="item.itemNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="码头:" prop="wharfxId">
        <el-select v-model="searchFrom.wharfxId"  @change="wharfxIdChange()">
          <el-option
            v-for="(item,index) in wharfOptions"
            :key="index"
            :label="item.showName"
            :value="item.itemNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物料名称:" prop="goodsName">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.goodsName"></el-input>
      </el-form-item>
      <el-form-item label="车队:" prop="fleet">
        <el-select v-model="searchFrom.fleet" placeholder="请选择">
          <el-option
            v-for="(item,index) in fleetOptions"
            :key="index"
            :label="item.fleetName"
            :value="item.fleet">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间:" prop="creatDate">
        <el-date-picker
          v-model="searchFrom.createStartTime"
          @change="startTimeChangeA"
          size="mini"
          style="width: 190px"
          placeholder="选择日期"
          type="date"
          value-format="yyyy-MM-dd"
        ></el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom.createEndTime"
          @change="startTimeChangeB"
          size="mini"
          style="width: 190px"
          placeholder="选择日期"
          type="date"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="有效时间:" prop="">
         <el-date-picker
          v-model="searchFrom.validStartTime"
          size="mini"
          style="width: 190px"
          placeholder="选择日期"
          type="date"
          value-format="yyyy-MM-dd"
        ></el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom.validEndTime"
          size="mini"
          style="width: 190px"
          placeholder="选择日期"
          type="date"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='001P004B001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="resetSearchFrom" btnCode='001P004B002'  v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'handleRowClick'
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="customerName" label="疏港计划" width="150" align="center" >
          <template slot-scope="scope"><div>
            <el-button  @click="handleBindClick(scope.row)" :disabled="(scope.row.distributionStatus != 1)||bindButtom" type="text" size="small" btnCode='001P004B003' v-if="btnFlg[2]">绑定</el-button>
            <el-button @click="handleSeeClick(scope.row)" type="text" size="small" btnCode='001P004B004' v-if="btnFlg[3]">查看</el-button>
            <el-button @click="handleUnBindClick(scope.row)" :disabled="(scope.row.distributionStatus != 1)||unBindButtom" type="text" size="small" btnCode='001P004B005' v-if="btnFlg[4]">解绑</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="purplanNo"    label="采购日计划号" align="center" width="230" show-overflow-tooltip></el-table-column>
        <el-table-column prop="distributionNo"   label="小计划号" align="center" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="distributionStatus"   label="计划状态" align="center"  show-overflow-tooltip>
          <template slot-scope="scope"><div>
            <el-tag v-if="scope.row.distributionStatus == 1" type="success">{{scope.row.status}}</el-tag>
            <el-tag v-if="scope.row.distributionStatus == 2" type="danger">{{scope.row.status}}</el-tag>
            <el-tag v-if="scope.row.distributionStatus == 3" type="info">{{scope.row.status}}</el-tag>
            <el-tag v-if="scope.row.distributionStatus == 4" type="warning">{{scope.row.status}}</el-tag>
          </div></template>
        </el-table-column>
        <el-table-column prop="fleetName"   label="车队" align="center" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="shipName" label="船名"  align="center" width="120" ></el-table-column>
        <el-table-column prop="goodsName"    label="物料名称"  width="100" align="center"></el-table-column>
        <el-table-column prop="distWeight" label="分配吨数" align="center" width="90">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.distWeight == '' || scope.row.distWeight == undefined || scope.row.distWeight == null">0</span>
            <span v-else>{{(scope.row.distWeight).toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="warehouseName" label="收货仓库1"  align="center" width="150"></el-table-column>
        <el-table-column prop="carnumLimit"    label="车数限制1"  width="100" align="center"></el-table-column>
        <el-table-column prop="locationName" label="库位1" align="center" width="100" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="forwarderName" label="货代"  align="center" width="120"></el-table-column>
        <el-table-column prop="wharfName"  label="港口" align="center" width="110" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="wharfxName" label="码头" align="center" width="110"></el-table-column>
        <el-table-column prop="areaName" label="场区"  align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="stackPosition"    label="垛位"  width="100" align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="" label="已运吨数" align="center" width="90" >
          <template slot-scope="scope"><div>
            <span v-if="scope.row.esuttleWeight == '' || scope.row.esuttleWeight == undefined || scope.row.esuttleWeight == null">0</span>
            <span v-else>{{(scope.row.esuttleWeight).toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="surplusWeight" label="剩余吨数"  align="center" width="90" >
          <template slot-scope="scope"><div>
            <span v-if="scope.row.surplusWeight == '' || scope.row.surplusWeight == undefined || scope.row.surplusWeight == null">0</span>
            <span v-else>{{(scope.row.surplusWeight).toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="completePercent" label="完成率"  align="center" width="110" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="createTime"    label="创建时间" align="center" width="180"></el-table-column>
        <el-table-column prop="validDate" label="有效时间"  align="center"  width="180"></el-table-column>
        <el-table-column prop="remark"    label="备注"  width="130" align="center" :formatter="emptyFn" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 绑定计划 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="bindMark"
    @close="closeBindDialog"
    width="1100px"
    center>
    <div v-loading='bindLoading'>
        <span>
          <div class="addinpBox">
            <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
            <span>船名：</span>
            <el-input  placeholder=""  maxlength="100" v-model="bindFrom.shipName" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>疏港计划号：</span>
            <el-input  placeholder="" maxlength="100" v-model="bindFrom.planNo" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>港口：</span>
            <el-select v-model="bindFrom.portFlag" placeholder="请选择" size="mini" @change="portOptionChangeDialog" style="width:150px;">
              <el-option
                v-for="(item,index) in portOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo">
              </el-option>
            </el-select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>码头：</span>
            <el-select v-model="bindFrom.wharfxId" placeholder="请选择" size="mini" @change="wharfxIdChange()">
              <el-option
              v-for="(item,index) in wharfOptionsForDialog"
              :key="index"
              :label="item.showName"
              :value="item.itemNo">
              </el-option>
            </el-select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br>
            <br>
            <span>物料名称：</span>
            <el-input  placeholder="" maxlength="100" v-model="bindFrom.goodsName" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button type="primary" size="mini" :disabled=bindButtomInDialogSearch @click="getBindSgPlan(1)">查询</el-button>
            <el-button type="primary" size="mini" :disabled=bindButtomInDialogReset @click="resetBindFrom">重置</el-button>
            <el-table
              :data="bindTableList"
              ref="bindTableList"
              height="350"
              border
              bordersize="mini"
              style="width:100%;margin:10px 0 10px 0"
              center
              @row-click = 'handleBindRowClick'
              :header-cell-style="{background:'#F5F5F5',color:'black'}"
              :header-row-style="{height:'35px'}"
              :row-style="{height:'25px'}"
              highlight-current-row>
              <el-table-column type="selection"  width="55" align="center"></el-table-column>
              <el-table-column  type="index" prop="" width="55" label="序号" align="center"></el-table-column>
              <el-table-column prop="planNo" label="疏港计划号（单号）" align="center" width="150"></el-table-column>
              <el-table-column prop="shipName" label="船名" align="center" width="120" ></el-table-column>
              <el-table-column prop="portName" label="港口" align="center" ></el-table-column>
              <el-table-column prop="wharfName" label="码头"  align="center" ></el-table-column>
              <el-table-column prop="goodsName" label="物料名称" align="center" ></el-table-column>
              <el-table-column prop="planWeight" label="重量" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="forwarderName" label="货代" align="center" :formatter="emptyFn"></el-table-column>
              <!-- <el-table-column prop="planOutWeight" label="车队计划量" align="center" width="120"></el-table-column> -->
              <el-table-column prop="endDate" label="有效期" align="center" width="180"></el-table-column>
              <el-table-column prop="fleetName" label="车队名称" align="center" width="180"></el-table-column>
            </el-table>
                <!-- 分页 10,25,50,100 -->
                 <div style="">
                  <el-pagination background
                    @size-change="handleSizeChangeB"
                    @current-change="handleCurrentChangeB"
                    :current-page="bindFrom.pageNo"
                    :page-sizes="[10,25,50,100]"
                    :page-size="bindFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="bindFrom.total">
                  </el-pagination>
                </div>
          </div>
        </span>
      <div style="width:170px;margin:15px auto;">
        <el-button @click="bindClick" :disabled="bindSureButtom" type="primary" size='mini'>确定</el-button>
        <el-button @click="closeBindDialog()" size='mini'>取消</el-button>
      </div>
    </div>
    </el-dialog>
    <!--点击查看-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="seeMark"
    width="1000px"
    center>
    <div v-loading='seeLoading'>
      <span>
        <!-- style="width:97%;margin-top:10px;margin-left:4%;margin-bottom:17px" -->
        <div class="addinpBox" >
                <el-table
                  :data="seetableList"
                  ref="table"
                  border
                  bordersize="mini"
                  style="width:97%;margin:17px auto;"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
                  <el-table-column prop="planNo"    label="疏港计划号（单号）" align="center" width="150"></el-table-column>
                  <el-table-column prop="shipName"   label="船名" align="center"  ></el-table-column>
                  <el-table-column property="wharfName" label="港口"  align="center" ></el-table-column>
                  <el-table-column prop="wharfxName"    label="码头" align="center" ></el-table-column>
                  <el-table-column property="goodsName" label="物料名称"  align="center" ></el-table-column>
                  <el-table-column prop="planWeight" label="重量" align="center" :formatter="formatterRowEmpty">
                    <template slot-scope="scope"><div>
                      <span v-if="scope.row.planWeight == undefined || scope.row.planWeight == null || scope.row.planWeight == ''">-</span>
                      <span v-else>{{scope.row.planWeight.toFixed(3)}}</span>
                    </div></template>
                  </el-table-column>
                  <el-table-column property="forwarderName" label="代理"  align="center" :formatter="emptyFn"></el-table-column>
                  <!-- <el-table-column prop="planOutWeight" label="车队计划量" align="center" width="120"></el-table-column> -->
                  <el-table-column prop="endDate"    label="有效期" align="center" width="180"></el-table-column>
                  <el-table-column prop="fleetName"    label="车队名称" align="center" width="180"></el-table-column>
                </el-table>
        </div>
      </span>
      <div style="width:60px;margin:15px auto;">
        <el-button @click="seeMark = false" size='mini'>关闭</el-button>
      </div>
      </div>
    </el-dialog>
    <!-- 解绑 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="unBindMark"
    @close="closeUnBindDialog"
    width="1100px"
    center>
    <div v-loading='unBindLoading'>
      <span>
        <span>
          <div class="addinpBox">
            <el-table
              :data="unBindTableList"
              ref="unBindTableList"
              border
              bordersize="mini"
              style="width:100%;margin:10px 0 10px 0"
              center
              @current-change="handleUnBindCurrentChange"
              :header-cell-style="{background:'#F5F5F5',color:'black'}"
              :header-row-style="{height:'35px'}"
              :row-style="{height:'25px'}"
              highlight-current-row>
              <!-- <el-table-column type="selection"  width="55" align="center"></el-table-column> -->
              <el-table-column  type="index" prop="" width="55" label="序号" align="center"></el-table-column>
              <el-table-column prop="planNo" label="疏港计划号（单号）" align="center" width="150"></el-table-column>
              <el-table-column prop="shipName" label="船名" align="center" width="120" ></el-table-column>
              <el-table-column prop="wharfName" label="港口" align="center" ></el-table-column>
              <el-table-column prop="wharfxName" label="码头"  align="center" ></el-table-column>
              <el-table-column prop="goodsName" label="物料名称" align="center" ></el-table-column>
              <el-table-column prop="planWeight" label="重量" align="center" :formatter="formatterRowEmpty">
                <template slot-scope="scope"><div>
                  <span v-if="scope.row.planWeight == undefined || scope.row.planWeight == null || scope.row.planWeight == ''">-</span>
                  <span v-else>{{scope.row.planWeight.toFixed(3)}}</span>
                </div></template>
              </el-table-column>
              <el-table-column prop="forwarderName" label="货代" align="center" :formatter="emptyFn"></el-table-column>
              <!-- <el-table-column prop="planOutWeight" label="车队计划量" align="center" width="120"></el-table-column> -->
              <el-table-column prop="endDate" label="有效期" align="center" width="180"></el-table-column>
              <el-table-column prop="fleetName" label="车队名称" align="center" width="180"></el-table-column>
            </el-table>
                <!-- 分页 10,25,50,100-->
                <!-- <div style="margin-left:28px;">
                  <el-pagination background
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :current-page="heTongFrom.pageNo"
                    :page-sizes="[10,25,50,100]"
                    :page-size="heTongFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="heTongFrom.total">
                  </el-pagination>
                </div>-->
        </div>
      </span>
      </span>
      <div style="width:170px;margin:15px auto;">
        <el-button @click="unBindClick" type="danger" plain  icon="el-icon-set-up" size='mini'>解绑</el-button>
        <el-button @click="closeUnBindDialog" size='mini'>关闭</el-button>
      </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  fleetList, // 车队列表
  getBindSGplanList, // 绑定疏港计划页面的展示列表
  getBindSGbigPlan, // 计划绑定页面点击绑定(查询操作)
  bindByDistributionIds, // 绑定确定按钮实施
  getFindBindedList, // 绑定页面点击查看按钮
  // getUnBindsgList, // 绑定页面点击解绑按钮（查询操作）
  unBindByPlanIds, // 解绑操作
  getPortOptions // 获取港口的下拉列表
} from '@/api/zhb-sgHarbour'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P004B001', '001P004B002', '001P004B003',
        '001P004B004', '001P004B005'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        wharfId: '',
        distributionNo: '',
        goodsName: '',
        fleet: '',
        createStartTime: '',
        createEndTime: '',
        wharfxId: '',
        validStartTime: '',
        validEndTime: ''
      },
      fleetOptions: [],
      value: '',
      tableList: [],
      tabLoading: false,
      // 新增
      addShengChengLoading: false,
      addFaBuLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      faBuId: '',
      planStatus: '',
      // 查看
      seetableList: [],
      seeMark: false,
      // 绑定计划
      bindMark: false,
      bindButtom: false,
      bindSureButtom: false,
      bindButtomInDialogReset: false,
      bindButtomInDialogSearch: false,
      wharfOptionsForDialog: [],
      portOptions: [], // 港口下拉列表
      wharfOptions: [], // 码头下拉列表
      bindRow: {},
      bindFrom: {
        fleet: '',
        shipName: '',
        planNo: '',
        goodsName: '',
        portFlag: '',
        wharfxId: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      }, // 绑定计划中的查询条件
      bindTableList: [],
      unBindButtom: false,
      // 解绑
      unBindMark: false,
      unBindTableList: [],
      unBindDistributionId: '',
      unBindRow: {},
      wharfxPlaceholder: '请先选择港口',
      bindLoading: false,
      seeLoading: false,
      unBindLoading: false
    }
  },
  created () {
    // this.getSeatchData(this.searchFrom)
    // this.getDictionary()
    this.getToDay()
    this.getSeatchData(this.searchFrom)
    this.fleetOptionsInit()
    this.sgPlanList()
    this.btnFlg = getBtn(this.btnIdArr, '/sgPlanManagement/planBinding')
    this.initPortOption()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  methods: {
    wharfxIdChange () {
      this.$forceUpdate()
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 年月日
    timeStamp2 (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log("time:" + JSON.stringify(now));
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    // 时间改变
    startTimeChangeA () {
      this.searchFrom.createStartTime = this.timeStamp2(this.searchFrom.createStartTime)
    },
    // 时间改变
    startTimeChangeB () {
      this.searchFrom.createEndTime = this.timeStamp2(this.searchFrom.createEndTime)
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      let dateStartStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime()))
      this.searchFrom.validStartTime = this.timeStamp2(new Date(dateStartStr).getTime())
      this.searchFrom.validEndTime = this.timeStamp2(new Date(dateStartStr).getTime() + 86400000)
      console.log(this.searchFrom.validStartTime, 'this.searchFrom.validStartTime')
      console.log(this.searchFrom.validEndTime, 'this.searchFrom.validEndTime')
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getBindSGplanList(this.searchFrom).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    initPortOption () {
      getPortOptions().then(res => {
        this.portOptions = res
      }).catch(err => {
        console.log(err.message)
        this.$message.error('获取港口下拉列表失败')
      })
    },
    portOptionChange (item) {
      if (item != null && item != undefined && item != '') {
        this.searchFrom.wharfxId = ''
        this.wharfxPlaceholder = '请选择'
        for (let index = 0; index < this.portOptions.length; index++) {
          let element = this.portOptions[index]
          if (element.itemNo == item) {
            this.wharfOptions = element.portList
            return
          }
        }
      }
    },
    portOptionChangeDialog (item) {
      if (item != null && item != undefined && item != '') {
        this.bindFrom.wharfxId = ''
        for (let index = 0; index < this.portOptions.length; index++) {
          let element = this.portOptions[index]
          if (element.itemNo == item) {
            this.wharfOptionsForDialog = element.portList
            return
          }
        }
      }
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    resetSearchFrom () {
      this.wharfOptions = []
      this.wharfxPlaceholder = '请先选择港口'
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        wharfId: '',
        distributionNo: '',
        goodsName: '',
        fleet: '',
        createStartTime: '',
        createEndTime: '',
        wharfxId: '',
        validStartTime: '',
        validEndTime: ''
      }
      this.getToDay()
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    handleUnBindCurrentChange (val) {
      this.unBindRow = val
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      this.$refs.tableRef.toggleRowSelection(row)
      this.changeFlag = row.newFlg
      this.changeData = row
      this.faBuId = row.id
      this.planStatus = row.planStatus
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 合同列表取消
    heTongQuXiaoClick () {
      this.heTongMark = false
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.heTongFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.heTongFrom.pageNo = val
      // this.getSearchData()
    },
    // 关闭绑定dialog
    closeBindDialog () {
      this.bindMark = false
      this.bindFrom = {
        id: '',
        fleet: '',
        shipName: '',
        portFlag: '',
        goodsName: '',
        wharfxId: '',
        pageNo: 1,
        pageSize: 10
      }
      this.bindRow = {}
      this.bindTableList = []
    },
    // 点击选中
    handleBindRowClick (row) {
      this.$refs.bindTableList.toggleRowSelection(row)
    },
    // 绑定
    handleBindClick (row) {
      this.title = '疏港计划'
      this.bindRow = row
      this.bindFrom.id = row.distributionId
      this.bindFrom.fleet = row.fleet
      this.bindFrom.shipName = row.shipName
      this.bindFrom.portFlag = row.wharfId
      this.bindFrom.goodsName = row.goodsName
      this.bindFrom.wharfxId = row.wharfxId
      // this.bindFrom.planNo = row.planNo
      // this.$set(this.bindFrom, 'planNo', row.planNo)
      for (let index = 0; index < this.portOptions.length; index++) {
        let element = this.portOptions[index]
        if (element.itemNo == this.bindFrom.portFlag) {
          this.wharfOptionsForDialog = element.portList
          break
        }
      }
      this.bindMark = true
      this.getBindSgPlan('0')
    },
    bindClick () {
      let rowSelected = []
      this.bindSureButtom = true
      rowSelected = this.$refs.bindTableList.selection
      if (rowSelected == null || rowSelected == undefined || rowSelected == '' || rowSelected.length == 0) {
        this.$message.error('请选择一条疏港计划进行绑定')
        this.bindSureButtom = false
        return
      }
      let planNoArray = []
      let planFlagArray = []
      rowSelected.forEach(element => {
        planNoArray.push(element.planNo)
        planFlagArray.push(element.planFlag)
      })

      if (planFlagArray.length == 0) {
        this.$message.error('请选择一条疏港计划进行绑定')
        this.bindSureButtom = false
        return
      }
      this.$confirm(
        `您确定要将疏港计划号为【${planNoArray}】绑定到分配计划【${this.bindRow.distributionNo}】上吗？`,
        '绑定',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'waring'
        }
      ).then(() => {
        this.bindLoading = true
        bindByDistributionIds(planFlagArray, this.bindFrom.id).then(res => {
          this.bindLoading = false
          this.bindSureButtom = false
          this.closeBindDialog()
          this.$message.success('绑定成功')
          this.bindMark = false
          this.getSeatchData(this.searchFrom)
        }).catch(err => {
          this.bindLoading = false
          this.bindSureButtom = false
          this.$message.error(err.message)
        })
      }).catch(() => {
        this.bindLoading = false
        this.bindSureButtom = false
        this.$message.info('已取消绑定')
      })
    },
    // 绑定计划分页
    handleSizeChangeB (val) {
      this.bindFrom.pageSize = val
      this.getBindSgPlan(1)
    },
    handleCurrentChangeB (val) {
      this.bindFrom.pageNo = val
      this.getBindSgPlan(1)
    },
    // 获取疏港计划
    getBindSgPlan (date) {
      this.bindButtom = true
      this.bindButtomInDialogReset = true
      this.bindButtomInDialogSearch = true
      this.bindLoading = true
      getBindSGbigPlan(this.bindFrom, date).then(res => {
        this.bindButtom = false
        this.bindLoading = false
        this.bindButtomInDialogReset = false
        this.bindButtomInDialogSearch = false
        this.bindTableList = res.list
        this.bindFrom.total = res.total
      }).catch(err => {
        console.log(err.message)
        this.bindButtom = false
        this.bindLoading = false
        this.bindButtomInDialogSearch = false
        this.bindButtomInDialogReset = false
        this.$message.error('获取疏港计划失败')
      })
    },

    handleUnBindClick (row) {
      this.unBindDistributionId = row.distributionId
      this.title = '可解绑'
      this.unBindMark = true
      let param = {
        id: '',
        fleet: ''
      }
      param.id = row.distributionId
      param.fleet = row.fleet
      this.unBindLoading = true
      getFindBindedList(param).then(res => {
        this.unBindLoading = false
        this.unBindTableList = res
      }).catch(err => {
        this.unBindLoading = false
        this.$message.error(err.message)
      })
    },

    // 点击列表查看
    handleSeeClick (row) {
      this.title = '已绑疏港计划'
      this.seeMark = true
      let param = {
        id: '',
        fleet: ''
      }
      param.id = row.distributionId
      param.fleet = row.fleet
      this.seeLoading = true
      getFindBindedList(param).then(res => {
        this.seeLoading = false
        this.seetableList = res
      }).catch(err => {
        this.seeLoading = false
        this.$message.error(err.message)
      })
    },
    fleetOptionsInit () {
      fleetList().then(res => {
        this.fleetOptions = res
        this.fleetOptions.unshift({ 'fleet': '', 'fleetName': '全部' })
      })
    },
    sgPlanList () {
      getBindSGplanList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
      })
    },
    closeUnBindDialog () {
      this.unBindMark = false
      this.unBindRow = {}
      this.unBindDistributionId = ''
      this.unBindTableList = []
      return true
    },
    resetBindFrom () {
      this.bindFrom.shipName = ''
      this.bindFrom.planNo = ''
      // this.bindFrom.portFlag = ''
      // this.bindFrom.wharfxId = ''
      this.bindFrom.goodsName = ''
      this.getBindSgPlan(1)
    },
    unBindClick () {
      if (this.unBindRow == null ||
          this.unBindRow == undefined ||
          this.unBindRow.distEvacuateId == undefined ||
          this.unBindRow.planId == undefined) {
        this.$message.error('请您选择一条疏港计划进行解绑')
        return
      }
      let params = {
        id: this.unBindRow.distEvacuateId,
        distributionId: this.unBindDistributionId,
        planId: this.unBindRow.planId
      }
      this.$confirm(`确定要解除疏港计划号为【${this.unBindRow.planNo}】的绑定吗？`,
        '解除绑定提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }
      ).then(() => {
        unBindByPlanIds(params).then(res => {
          this.$message.success('解绑成功')
          this.unBindMark = false
          this.getSeatchData(this.searchFrom)
        }).catch(err => {
          this.$message.error(err.message)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消绑定'
        })
      })
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 15px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}

//  /deep/ .inpBox .el-range-editor--mini .el-input__inner {
//    width: 150px;
// }
// .inpBox .el-date-editor{
//     width: 280px!important;
//  }
.searchBtnBox{
  margin-top: 10px;
  margin-left: -5px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
</style>
